import { Action, AsyncAction } from '../../../types/actions';
import { AddAdminToGroup, AddNewAdmin, CreateChannelRedirect, DeleteChannelRedirect, GetAdmins, GetChannelRedirects, RemoveAdminFromAllGroups, RemoveAdminFromGroup, UnlockEmail, UpdateChannelRedirect, UpdateChannels } from '../../../connection/auth';
import { BLAdmin } from '../../../types/working-model';
import { ChannelRedirect } from '../../../components/admin/settings/channel-redirects';

export const GET_ADMINS = "GET_ADMINS";
export function getAdmins(token: string): AsyncAction {
	return {
		type: GET_ADMINS,
		promise: GetAdmins(token)
	};
}

export const GET_ADMINS_AND_LOCKED_EMAILS = "GET_ADMINS_AND_LOCKED_EMAILS";
export function getAdminsAndLockedEmails(token: string): AsyncAction {
	const includeLockedEmails = true;
	return {
		type: GET_ADMINS_AND_LOCKED_EMAILS,
		promise: GetAdmins(token, includeLockedEmails)
	};
}

export const UNLOCK_EMAIL = "UNLOCK_EMAIL";
export function unlockEmail(token: string, email: string): AsyncAction {
	return {
		type: UNLOCK_EMAIL,
		promise: UnlockEmail(token, email)
	};
}

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export function updatePermissions(token: string, profile: BLAdmin, needsInviteEmail: boolean = false): AsyncAction {
	const ssoChannels = profile.channels_using_sso ? profile.channels_using_sso : [];
	return {
		type: UPDATE_PERMISSIONS,
		promise: UpdateChannels(token, profile.id, profile.channels, ssoChannels, needsInviteEmail)
	};
}

export const SET_WORKING_PERMISSIONS = "SET_WORKING_PERMISSIONS";
export function setWorkingPermissions(permissions: string[]): Action {
	return {
		type: SET_WORKING_PERMISSIONS,
		payload: permissions
	};
}

export const ADD_ADMIN = "ADD_ADMIN";
export function addAdmin(token: string, email: string, permissions: string[], isSSO: boolean): AsyncAction {
	return {
		type: ADD_ADMIN,
		promise: AddNewAdmin(token, email, permissions, isSSO)
	};
}

export const REMOVE_ADMIN = "REMOVE_ADMIN";
export function removeAdmin(token: string, profile: BLAdmin): AsyncAction {
	const ssoChannels = profile.channels_using_sso ? profile.channels_using_sso : [];
	return {
		type: REMOVE_ADMIN,
		promise: UpdateChannels(token, profile.id, profile.channels, ssoChannels)
	};
}

export const GET_CHANNEL_REDIRECTS = "GET_CHANNEL_REDIRECTS";
export function getChannelRedirects(token: string, channel: number): AsyncAction {
	return {
		type: GET_CHANNEL_REDIRECTS,
		promise: GetChannelRedirects(token, channel)
	};
}

export const CREATE_CHANNEL_REDIRECT = "CREATE_CHANNEL_REDIRECT";
export function createChannelRedirect(token: string, redirect: Omit<ChannelRedirect, 'id'>): AsyncAction {
	return {
		type: CREATE_CHANNEL_REDIRECT,
		promise: CreateChannelRedirect(token, redirect)
	};
}

export const UPDATE_CHANNEL_REDIRECT = "UPDATE_CHANNEL_REDIRECT";
export function updateChannelRedirect(token: string, redirect: ChannelRedirect): AsyncAction {
	return {
		type: UPDATE_CHANNEL_REDIRECT,
		promise: UpdateChannelRedirect(token, redirect)
	};
}

export const DELETE_CHANNEL_REDIRECT = "DELETE_CHANNEL_REDIRECT";
export function deleteChannelRedirect(token: string, redirect: ChannelRedirect): AsyncAction {
	return {
		type: DELETE_CHANNEL_REDIRECT,
		promise: DeleteChannelRedirect(token, redirect)
	};
}

export const ADD_ADMIN_TO_GROUP = "ADD_ADMIN_TO_GROUP";
export function addAdminToGroup(token: string, admin_id: number, group_uuid: string, channel: number): AsyncAction {
	return {
		type: ADD_ADMIN_TO_GROUP,
		promise: AddAdminToGroup(token, admin_id, group_uuid, channel)
	};
}

export const REMOVE_ADMIN_FROM_GROUP = "REMOVE_ADMIN_FROM_GROUP";
export function removeAdminFromGroup(token: string, admin_id: number, group_uuid: string, channel: number): AsyncAction {
	return {
		type: REMOVE_ADMIN_FROM_GROUP,
		promise: RemoveAdminFromGroup(token, admin_id, group_uuid, channel)
	};
}

export const REMOVE_ADMIN_FROM_ALL_GROUPS = "REMOVE_ADMIN_FROM_ALL_GROUPS";
export function removeAdminFromAllGroups(token: string, admin_id: number, channel: number): AsyncAction {
	return {
		type: REMOVE_ADMIN_FROM_ALL_GROUPS,
		promise: RemoveAdminFromAllGroups(token, admin_id, channel)
	};
}

export const CLEAR_BL_ADMIN_ERROR = "CLEAR_BL_ADMIN_ERROR";
export function clearBlAdminError(): Action {
	return {
		type: CLEAR_BL_ADMIN_ERROR,
		payload: null
	};
}